var sliders = {
    selectors: {
        phone:  '[data-slick-phone]',
        copy:  '[data-slick-copy]'
    },
    init: function() {
        var self  = this,
        $phoneSlider = $( self.selectors.phone ),
        $copySlider = $( self.selectors.copy );

        $phoneSlider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            autoplay: true,
            autoplaySpeed: 10000,
            asNavFor: self.selectors.copy
        });
        $copySlider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: true,
            asNavFor: self.selectors.phone,
        });
    }
}

export { sliders };
